import React from 'react';
import { Box, Button, Link } from '@99designs/emu';
import { FormattedReactMessage, formatMessage } from '@99designs/frontend-components/i18n';
import { linkTo } from '@99designs/routing';
import { Layout } from '../Layout';

interface Props {
    redirectUrl: string;
    onTermsAcceptance: (target: string) => void;
}

export function TermsAndConditionsUpdate({ redirectUrl, onTermsAcceptance }: Props) {
    return (
        <Layout
            title={__('Update to our Terms and Conditions')}
            heading={__('Update to our Terms and Conditions')}
        >
            <Box>
                <p>
                    {__(
                        'We would like to inform you of a recent change we’ve made to our Terms and Conditions.'
                    )}
                </p>
                <p>
                    {formatMessage(
                        __(
                            'On {date}, all user accounts will be migrated to Vista. This is due to a new single sign-on functionality that allows users to seamlessly move across 99designs, VistaPrint and VistaCreate with one account.'
                        ),
                        { date: '2022/09/28' }
                    )}
                </p>
                <p>
                    <FormattedReactMessage
                        message={__(
                            'Please take a moment to read the change under <Link>6. Accounts</Link>. By continuing to use our services after {date}, you are agreeing to our updated Terms and Conditions.'
                        )}
                        replacements={{
                            Link: <Link href={linkTo.termsAndConditions()} target="_blank" />,
                        }}
                        values={{
                            date: '2022/09/28',
                        }}
                    />
                </p>
                <p>
                    <Link
                        href={linkTo.supportUrl('8788014705428', 'articles', __LANG__)}
                        target="_blank"
                    >
                        {__('Learn more')}
                    </Link>
                </p>
                <Button
                    href={redirectUrl}
                    appearance="primary"
                    width="fill"
                    onClick={(e) => {
                        e.preventDefault();
                        onTermsAcceptance(redirectUrl);
                    }}
                >
                    {__('Continue')}
                </Button>
            </Box>
        </Layout>
    );
}
